import { CustomElement, resolve } from 'aurelia';
import { LogsAdminService } from '../../services';
import template from './logs-admin-panel.html';
import './logs-admin-panel.css';

// Admin-only modal that shows the tail of the most recently modified file under the app's logs/
// folder. Opened from the admin menu; all state and the load call live in LogsAdminService.
// Read-only.
export class LogsAdminPanelElement {
  readonly logs: LogsAdminService = resolve(LogsAdminService);
}

export const LogsAdminPanel = CustomElement.define({
  name: 'logs-admin-panel',
  template
}, LogsAdminPanelElement);
